export const START_FETCHING_DOCUMENTS = 'START_FETCHING_DOCUMENTS';
export const FETCHED_DOCUMENTS = 'FETCHED_DOCUMENTS';
export const START_FETCHING_DOCUMENT = 'START_FETCHING_DOCUMENT';
export const FETCHED_DOCUMENT = 'FETCHED_DOCUMENT';
export const START_PUBLISHING_DOCUMENT = 'START_PUBLISHING_DOCUMENT';
export const PUBLISHED_DOCUMENT = 'PUBLISHED_DOCUMENT';
export const START_UPDATING_DOCUMENT = 'START_UPDATING_DOCUMENT';
export const UPDATED_DOCUMENT = 'UPDATED_DOCUMENT';
export const UPDATE_DOCUMENT = 'UPDATE_DOCUMENT';
export const DELETE_DOCUMENTS = 'DELETE_DOCUMENTS';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const SET_CHANNELS = 'SET_CHANNELS';
export const SET_SUBCHANNELS = 'SET_SUBCHANNELS';
export const SET_FILTER_CHANNELS = 'SET_FILTER_CHANNELS';
export const SET_FILTER_SUBCHANNELS = 'SET_FILTER_SUBCHANNELS';
export const SET_TOP_FILES = 'SET_TOP_FILES';
export const SET_TOP_CHANNELS = 'SET_TOP_CHANNELS';
export const SET_TOP_USERS = 'SET_TOP_USERS';
export const SET_DAILY_RESULTS = 'SET_DAILY_RESULTS';
export const SET_ANALYTICS_STATE = 'SET_ANALYTICS_STATE';
export const SET_ERROR = 'SET_ERROR';
export const SET_TABLE_PAGE_SIZE = 'SET_TABLE_PAGE_SIZE';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const START_FETCHING_REPLACEMENTS = 'START_FETCHING_REPLACEMENTS';
export const FETCHED_REPLACEMENTS = 'FETCHED_REPLACEMENTS';
export const START_FETCHING_JOBS = 'START_FETCHING_JOBS';
export const FETCHED_JOBS = 'FETCHED_JOBS';
export const START_FETCHING_JOB = 'START_FETCHING_JOB';
export const FETCHED_JOB = 'FETCHED_JOB';
export const START_ADDING_JOB = 'START_ADDING_JOB';
export const ADDED_JOB = 'ADDED_JOB';
export const START_FETCHING_PODCASTS = 'START_FETCHING_PODCASTS';
export const FETCHED_PODCASTS = 'FETCHED_PODCASTS';
export const START_ADDING_PODCAST = 'START_ADDING_PODCAST';
export const ADDED_PODCAST = 'ADDED_PODCAST';
export const START_UPDATING_PODCAST = 'START_UPDATING_PODCAST';
export const UPDATED_PODCAST = 'UPDATED_PODCAST';
export const START_FETCHING_PODCAST = 'START_FETCHING_PODCAST';
export const FETCHED_PODCAST = 'FETCHED_PODCAST';
export const CLEAR_PODCAST = 'CLEAR_PODCAST';
export const UPDATED_SELECTED_ACRONYMS = 'UPDATED_SELECTED_ACRONYMS';
export const CHANGE_ACRONYMS_FILTER = 'CHANGE_ACRONYMS_FILTER';
export const START_ADDING_URL = 'START_ADDING_URL';
export const ADDED_URL = 'ADDED_PODCAST';
export const START_FETCHING_URLS = 'START_FETCHING_URLS';
export const FETCHED_URLS = 'FETCHED_URLS';
export const START_FETCHING_URL = 'START_FETCHING_URL';
export const FETCHED_URL = 'FETCHED_URL';
export const CLEAR_URL = 'CLEAR_URL';
export const START_FETCHING_USER_INFO = 'START_FETCHING_USER_INFO';
export const FETCHED_USER_INFO = 'FETCHED_USER_INFO';
export const START_FETCHING_USERS = 'START_FETCHING_USERS';
export const FETCHED_USERS = 'FETCHED_USERS';
export const START_FETCHING_GROUPS = 'START_FETCHING_GROUPS';
export const FETCHED_GROUPS = 'FETCHED_GROUPS';
export const START_ADDING_GROUP = 'START_ADDING_GROUP';
export const ADDED_GROUP = 'ADDED_GROUP';
export const START_UPDATING_GROUP = 'START_UPDATING_GROUP';
export const UPDATED_GROUP = 'UPDATED_GROUP';
export const START_ADDING_USER = 'START_ADDING_USER';
export const ADDED_USER = 'ADDED_USER';
export const START_UPDATING_USER = 'START_UPDATING_USER';
export const UPDATED_USER = 'UPDATED_USER';
export const START_FETCHING_HISTORY = 'START_FETCHING_HISTORY';
export const FETCHED_HISTORY = 'FETCHED_HISTORY';
export const SET_FILTERED_DOCUMENTS = 'SET_FILTERED_DOCUMENTS';
export const DELETE_FILTERED_DOCUMENTS = 'DELETE_FILTERED_DOCUMENTS';
